import { toMapFn } from "~/common/utils/reducers";
import { CheckoutCountriesContextProvider } from "~/features/cart/checkout/components/CheckoutOptimeCountriesContext";
import { useOnMount } from "~/common/hooks/useOnMount";
import Spinner from "~/common/components/Spinner/Spinner";
import CheckoutCart from "~/features/cart/checkout/components/CheckoutCart";
import CheckoutFooter from "~/features/cart/checkout/components/CheckoutFooter";
import { type RootState } from "~/app/store";
import { useDispatch, useSelector } from "react-redux";
import { checkoutPageMounted } from "~/features/cart/cart/redux/actions/checkoutPageActions";
import { type DropdownEntry } from "~/common/types";
import { CartPageContextProvider } from "~/features/cart/cart/CartPageContext";
import { Box } from "~/common/mui";

export function createCheckoutPage(data: { countriesJSON: string }) {
  const list: { isocode: string; name: string }[] = JSON.parse(data.countriesJSON);

  const countriesList: DropdownEntry<string>[] = list.map((item) => ({
    value: item.isocode,
    label: item.name,
    stringLabel: item.name,
  }));

  const countryByCode = toMapFn(
    list,
    (item) => item.isocode,
    (item) => item.name,
  );

  return (
    <CheckoutCountriesContextProvider value={{ countriesList, countryByCode }}>
      <CartPageContextProvider initialDisableCheckout={false} initialShowSubtotal={true}>
        <CheckoutPage />
      </CartPageContextProvider>
    </CheckoutCountriesContextProvider>
  );
}

const CheckoutPage = () => {
  const dispatch = useDispatch();
  useOnMount(() => {
    dispatch(checkoutPageMounted());
  });

  const isLoading = useSelector(selectIsLoading);

  return (
    <>
      {/* TODO: remove extra padding and white background from root page container  */}
      {isLoading && (
        <Box
          sx={{
            display: "flex",
            height: "80vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner className="w-100" />
        </Box>
      )}

      {!isLoading && (
        <>
          <CheckoutCart />

          <CheckoutFooter />
        </>
      )}
    </>
  );
};

const selectIsLoading = (state: RootState) => state.checkoutPage.loading;
